import classNames from '@jd/jmtd-tools/es/classnames';
import React from 'react';
/**
 * 目前只支持最多前三名排行榜单，默认值为3
 */

export default function TableFormatterRank(_ref) {
  var _ref$topNum = _ref.topNum,
      topNum = _ref$topNum === void 0 ? 3 : _ref$topNum,
      _ref$getRank = _ref.getRank,
      getRank = _ref$getRank === void 0 ? function (x) {
    return x;
  } : _ref$getRank;
  return {
    fitContent: true,
    align: 'center',
    render: function render() {
      var ranking = getRank.apply(void 0, arguments);
      var isTop = ranking <= Math.min(topNum, 3);
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('jmtd-table-formatter-rank', isTop ? "jmtd-table-formatter-rank-icon jmtd-table-formatter-rank-icon-".concat(ranking) : 'jmtd-table-formatter-rank-number')
      }, isTop ? '' : ranking);
    }
  };
}